import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Injectable()
export class FormToggleService {
  private isLoginFormSource = new BehaviorSubject<boolean>(true);

  isLoginForm = this.isLoginFormSource.asObservable();

  toggle() {
    this.isLoginFormSource.next(!this.isLoginFormSource.value);
  }
}
